import script from "./ChoosePlanDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ChoosePlanDialog.vue?vue&type=script&setup=true&lang=js"

import "./ChoosePlanDialog.vue?vue&type=style&index=0&id=76aa8ec4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76aa8ec4"]])

export default __exports__